import React from 'react'
import selectors from '../../store/selectors'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import * as actions from '../../store/actions'
import * as appActions from 'App/actions'
import styled from 'styled-components'
import Header from '../Header'
import vars from '../common/vars'
import Scroll from '../Scroll'

const TableOfContents = ({ enabled, items, toggle, handleClick }) => {
  if (!enabled) { return null }

  return (
    <Container className="toc-container">
      <Header closeChat={toggle} />
      <Scroll style={{ height: 450 }}>
        {items.map((button, i) =>
          <div key={button.text + i}>
            <Button onClick={handleClick.bind(null, button)}>
              {button.text}
            </Button>
          </div>
        )}
      </Scroll>
    </Container>
  )
}

const Container = styled.div`
  border: 1px solid ${props => props.theme.primaryColor};
  border-top: none;
  border-radius: 7px;
  margin-right: 10px;
  background: #fff;
`

const Button = styled.button`
  width: 100%;
  padding: 15px 10px;
  text-align: left;
  background: none;
  cursor: pointer;
  border: none;
  outline: 0;
  &:hover {
    background: ${vars.grey1};
  }
`

const mapStateToProps = createStructuredSelector({
  enabled: selectors.selectShowTOC,
  items: selectors.selectTocItems
})

const mapDispatchToProps = dispatch => ({
  handleClick: button => dispatch(appActions.menuItemClick(button)),
  toggle: () => dispatch(actions.toggleTOC())
})

export default connect(mapStateToProps, mapDispatchToProps)(TableOfContents)



// WEBPACK FOOTER //
// ./src/ChatWidget/components/TableOfContents/index.js